import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	documentTitle: {
		id: 'archived-plans-main.document-title',
		defaultMessage: 'Archived plans',
		description: 'Document title for the "Archived" page.',
	},
});
